import { Navigate, useParams } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import useJsonLd from "@/hooks/useJsonLd";
import QuoteBlock from "@/components/QuoteBlock";
import DisciplineHero from "@/components/discipline/DisciplineHero";
import { Pains, Deliverables, StandardsSoftware, Process } from "@/components/discipline/DisciplineSections";
import { Faq, RelatedLinks, RelatedGuides } from "@/components/discipline/DisciplineExtras";
import { getDiscipline } from "@/data/disciplines";
import { breadcrumb, disciplineLd, faqLd } from "@/lib/jsonLd";

export default function DisciplinePage() {
  const { slug } = useParams();
  const d = getDiscipline(slug);

  useSeo({
    title: d ? `${d.name} — ${d.primaryKeyword} · Tri-Axis XYZ` : "Discipline — Tri-Axis XYZ",
    description: d ? `${d.intro} Serving firms in the USA, Canada and Australia.` : undefined,
  });
  useJsonLd(d ? disciplineLd(d) : null, "discipline-service");
  useJsonLd(d ? faqLd(d.faqs) : null, "discipline-faq");
  useJsonLd(
    d ? breadcrumb([{ name: "Home", path: "/" }, { name: "Disciplines", path: "/disciplines" }, { name: d.name, path: `/disciplines/${d.slug}` }]) : null,
    "discipline-bc",
  );

  if (!d) return <Navigate to="/disciplines" replace />;

  return (
    <div data-testid={`page-discipline-${d.slug}`}>
      <DisciplineHero d={d} />
      <Pains d={d} />
      <Deliverables d={d} />
      <StandardsSoftware d={d} />
      <Process d={d} />
      <Faq d={d} />
      <RelatedGuides category={d.blogCategory} />
      <RelatedLinks d={d} />
      <div id="discipline-quote">
        <QuoteBlock serviceSlug={`discipline-${d.slug}`} serviceName={d.name} />
      </div>
    </div>
  );
}
